const borders = {
  light: `solid 1px muted`,
}

export default borders
